import { useEffect, useState } from 'react';

const useIsChromebook = () => {
  const [isChromebook, setIsChromebook] = useState(false);
  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isChromeBookFound = userAgent.includes('cros');
    setIsChromebook(isChromeBookFound);
  }, []);

  return isChromebook;
};

export default useIsChromebook;
